import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { getCmsPage } from "../../services/cms.service";

export function useCms(pageSlug: string) {
  const { i18n } = useTranslation();
  const lang = (i18n.language || "en").split("-")[0];

  const [content, setContent] = useState<Record<string, any>>({});

  useEffect(() => {
    let active = true;
    getCmsPage(pageSlug, lang)
      .then((data) => {
        if (active) setContent(data);
      })
      .catch((error) =>
        console.error(`Unable to load CMS page ${pageSlug} (${lang})`, error),
      );
    return () => {
      active = false;
    };
  }, [pageSlug, lang]);

  const get = useCallback(
    (path: string, fallback: any = "") => {
      const value = path
        .split(".")
        .reduce<any>((current, part) => current?.[part], content);
      return value === undefined || value === null || value === "" ? fallback : value;
    },
    [content],
  );

  return { content, get };
}